import React from 'react';
import './SpiritualBackground.css';

const SpiritualBackground = () => {
    return (
        <div className="spiritual-background">
            <div className="spiritual-gradient"></div>
            <div className="spiritual-noise"></div>
        </div>
    );
};

export default SpiritualBackground;
